<template>
  <v-modal
    v-if="showSidebar"
    vertical
    modal-class="navigation-page-modal"
    @close="toggleSidebar"
  >
    <template slot="#pages">
      <tabbar-content />
    </template>
  </v-modal>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex"

import { isPresent } from "@/lib/utils"

export default {
  components: {
    TabbarContent: () => import("@/components/TabbarContent")
  },

  computed: {
    ...mapState("tabbar", ["showSidebar"]),
    ...mapGetters("tabbar", ["tabbarLinks"]),
    ...mapState(["global"])
  },

  methods: {
    isPresent,

    ...mapMutations("tabbar", ["toggleSidebar", "setShowSidebar"])
  },

  watch: {
    showSidebar() {
      if (this.showSidebar) {
        this.$router.push("#pages")
      } else {
        this.$router.removeHash()
      }
    },

    "$route.path": function(newPath, oldPath) {
      if (newPath !== oldPath) {
        this.setShowSidebar(false)
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/styles/variables";

.navigation-page-modal {
  .v-tabbar__logo {
    padding-top: env(safe-area-inset-top);
  }
}
</style>
